import React from 'react';
import { compose, graphql } from 'react-apollo';
import { withRouter } from 'react-router';
import getLocale from 'containers/LanguageProvider/graphql/getlocale.gql';
import updateLocale from 'containers/LanguageProvider/graphql/updateLocale.gql';
import Link from 'components/Link';

export class LocaleToggle extends React.PureComponent {
  // constructor(props) {
  //   super(props);

  //   const langValue = props.languageState.locale === 'en' ? 'ar' : 'en';
  //   const pathName = path.substr(pathLang ? 4 : 1);
  //   this.nextPath = `/${langValue}/${pathName}`;
  //   this.nextLocation = `${window.location.origin}${this.nextPath}`;
  // }

  componentWillReceiveProps(nextProps) {
    if (nextProps.languageState.locale === 'ar') {
      document.body.classList.add('ar');
    } else {
      document.body.classList.remove('ar');
    }
  }

  toggleLocale = (e) => {
    e.preventDefault();
    const path = window.location.pathname;
    let pathLang = path.split('/')[1];
    pathLang = ['en', 'ar'].includes(pathLang) ? pathLang : undefined;
    const langValue = this.props.languageState.locale === 'en' ? 'ar' : 'en';
    const pathName = path.substr(pathLang ? 4 : 1);
    const nextPath = `/${langValue}/${pathName}`;
    const nextLocation = `${window.location.origin}${nextPath}`;
    window.location = nextLocation;


    // const langValue = this.props.languageState.locale === 'en' ? 'ar' : 'en';

    // const pathName = path.substr(pathLang ? 4 : 1);
    // const newPath = `${window.location.origin}/${langValue}/${pathName}`;

    // this.props.updateLocale({
    //   variables: {
    //     locale: langValue,
    //   },
    // });
    // localStorage.setItem(LOCALE, langValue);
    // langValue == 'ar' ? document.body.classList.add('ar') : document.body.classList.remove('ar')
  };

  render() {
    return (
      <Link to="_switch" onClick={this.toggleLocale} className={this.props.className}>
        {this.props.languageState.locale === 'en' ? 'عربي' : 'English'}
      </Link>
    );
  }
}

export default compose(
  withRouter,
  graphql(updateLocale, { name: 'updateLocale' }),
  graphql(getLocale, {
    props: ({ data: { languageState } }) => ({
      languageState,
    }),
  })
)(LocaleToggle);



// WEBPACK FOOTER //
// ./app/components/LocaleToggle/index.js